// extracted by mini-css-extract-plugin
module.exports = {"block":"UserAuth_block__Bx1LM"};